<template>
  <section class="theme_5">
    <div class="content_box">
      <h2 class="title">沉浸式主题生态</h2>
      <p class="desc">提供便捷的主题适配接入方式，满足不同品牌对多屏及氛围灯间的联动需求，深度定制图标、控件、主题色、3D 场景<br /> 等不同元素。支持打造专属主题商店和一站式管理平台，便于主题的管理、分析及运营</p>
      <div class="bg" bg-url="@/plan/assets/image/5/black.png" v-bg></div>
    </div>

    <div class="content_box content2_5">
      <h2 class="title">沉浸式主题生态</h2>
      <p class="desc">提供便捷的主题适配接入方式，满足不同品牌对多屏及氛围灯间的联动需求，深度定制图标、控件、主题色、3D 场景<br /> 等不同元素。支持打造专属主题商店和一站式管理平台，便于主题的管理、分析及运营</p>
      <div class="bg" bg-url="@/plan/assets/image/5/white.png" v-bg></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Theme',
  
  methods: {
    pagePin() {
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.theme_5',
          end: '+=1500',
          pin: true
        }
      })
    },

    switchTheme() {
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.content2_5',
          start: '750px top',
          end: '750px top',
          scrub: 0.05,
          onEnter: () => {
            this.$gsap.to('.content2_5', { opacity: 1, duration: 1 })
          },
          onEnterBack: () => {
            this.$gsap.to('.content2_5', { opacity: 0, duration: 1 })
          }
        }
      })
    },

    onLaunch() {
      this.pagePin()
      this.switchTheme()
    }
  }
}
</script>

<style lang="less" scoped>
.theme_5 {
  height: 100vh;
  min-height: 1130px;
  position: relative;
  overflow: hidden;
  
  .content_box {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    height: 100%;
    background-color: #000;
  }
  .content2_5 {
    background-color: #fff;
    opacity: 0;

    .title {
      color: #000;
    }
    
    .desc {
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .title {
    font-weight: 700;
    font-size: 46px;
    line-height: 65px;
    text-align: center;
    color: #fff;
    margin: 100px 0 10px 0;
  }
  .bg {
    height: 800px;
    background-size: 2432px 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .desc {
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 40px 0;
    text-align: center;
  }
}
</style>
